import { line, roundRect2 } from '../../renderers';

type GridLineStyleMode = 'solid' | 'dotted';

interface PaintGridLineStyleButtonOptions {
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  enabled: boolean;
  animated: boolean;
  mode: GridLineStyleMode;
  themeColor: string;
}

const ACTIVE_STYLE = '#2f80ed';
const INACTIVE_STYLE = '#9d9d9d';
const DISABLED_STYLE = '#b8b8b8';
const ENABLED_BACKGROUND = 'lightgray';
const DISABLED_BACKGROUND = '#eeeeee';
const BASE_BUTTON_SIZE = 30;
const SAMPLE_HALF_WIDTH = 10;
const SAMPLE_STROKE_WIDTH = 3;
const DOTTED_SAMPLE_GAP = 6;

const drawDottedSample = (
  ctx: CanvasRenderingContext2D,
  x1: number,
  x2: number,
  y: number,
  color: string,
  scale: number
): void => {
  const dashLength = (x2 - x1 - DOTTED_SAMPLE_GAP * scale) / 2;
  const secondDashStart = x2 - dashLength;
  const strokeWidth = SAMPLE_STROKE_WIDTH * scale;

  line(ctx, x1, y, x1 + dashLength, y, strokeWidth, color);
  line(ctx, secondDashStart, y, x2, y, strokeWidth, color);
};

export const paintGridLineStyleButton = ({
  ctx,
  width,
  height,
  enabled,
  animated,
  mode,
  themeColor,
}: PaintGridLineStyleButtonOptions): void => {
  const background = enabled
    ? animated
      ? themeColor
      : ENABLED_BACKGROUND
    : DISABLED_BACKGROUND;
  const selectedColor = enabled ? ACTIVE_STYLE : DISABLED_STYLE;
  const unselectedColor = enabled ? INACTIVE_STYLE : DISABLED_STYLE;
  const solidColor = mode === 'solid' ? selectedColor : unselectedColor;
  const dottedColor = mode === 'dotted' ? selectedColor : unselectedColor;
  const scale = Math.min(width, height) / BASE_BUTTON_SIZE;
  const x1 = width / 2 - SAMPLE_HALF_WIDTH * scale;
  const x2 = width / 2 + SAMPLE_HALF_WIDTH * scale;
  const solidY = height / 2 - 3 * scale;
  const dottedY = height / 2 + 4 * scale;
  const strokeWidth = SAMPLE_STROKE_WIDTH * scale;

  roundRect2(
    ctx,
    0,
    0,
    width,
    height,
    6,
    background,
    undefined,
    undefined,
    true
  );

  line(ctx, x1, solidY, x2, solidY, strokeWidth, solidColor);
  drawDottedSample(ctx, x1, x2, dottedY, dottedColor, scale);
};
